let RuleParamsMap = {
    scenario: ['data'],
    or: ['conditions'],
    and: ['conditions'],
    when: ['condition'],
    skipOnEmpty: ['condition'],
    emptyOn: ['callback'],
    default: ['value'],
    each: ['rules'],
    dynamic: ['callback'],
    readonly: [],
    disabled: [],
    visible: [],
    not: [],
    sync: ['fields'],

    // VALIDATORS

    required: ['invalidateFalse'],
    match: ['regex', 'flags'],

    between: ['from', 'to', 'inclusion'],
    equals: ['other', 'isField', 'strict'],
    contains: ['target'],
    startsWith: ['target'],
    endsWith: ['target'],
    minlength: ['length'],
    maxlength: ['length'],
    min: ['min'],
    max: ['max'],
    in: ['data'],
    has: ['data'],
    hasOne: ['data'],

    date: ['format'],
    time: ['format'],
    datetime: ['format'],
    before: ['target', 'inclusion', 'format'],
    after: ['target', 'inclusion', 'format'],
    dateBetween: ['from', 'to', 'inclusivity', 'format', 'units'],
    datetimeBetween: ['from', 'to', 'inclusivity', 'format', 'units'],

    alpha: ['locale'],
    alphadash: ['locale'],
    alphaspaces: ['locale'],
    alphanumeric: ['locale'],
    decimal: ['decimals', 'separator'],
    digits: ['length'],
    integer: [],
    numeric: [],

    email: [],
    url: ['requireProtocol'],
    ip: ['version']
}

let MultiParamsRules = [
    'in',
    'has',
    'hasOne',
    'or',
    'and',
    'each',
    'when',
    'scenario',
    'sync'
]

export { RuleParamsMap, MultiParamsRules }
